<script>
export default {
    props: {
        href: String,
        dark: Boolean,
        gradient: Boolean,
    },
    emits: ["buttonClick"],
    methods: {
        handleClick() {
            this.$emit('buttonClick');
        },
    },
};
</script>

<template>
    <a class="button" v-bind:class="{ 'button--dark': dark }" v-if="href" :href="href">
        <span class="button__mask" area-hidden="true"></span>
        <slot></slot>
    </a>
    <button class="button" v-bind:class="{ 'button--dark': dark, 'button--gradient': gradient }" v-else @click="handleClick">
        <span class="button__mask" area-hidden="true"></span>
        <slot></slot>
    </button>
</template>

<style lang="scss" scoped>
.button {
    $root: &;
    border-radius: 100vmax;
    position: relative;
    background-color: transparent;
    display: inline-flex;
    gap: 14px;
    padding: 0 32px;
    justify-content: center;
    align-items: center;
    min-height: 56px;
    min-width: 100px;
    text-decoration: none;
    font-size: 1.8rem;
    color: #000;
    overflow: hidden;

    &--dark {
        filter: invert(1);
    }

    &--gradient {
        filter: invert(0);
        color: #fff;

        &::before {
            content: '';
            position: absolute;
            inset: 0;
            z-index: -2;
            background-image: linear-gradient(
                114.31deg,
                #076fc9 -39.46%,
                #6d2b9a 83.83%
                );
            transition: opacity 0.8s ease;
            will-change: opacity;
        }

        &::after {
            content: '';
            position: absolute;
            inset: 0;
            opacity: 0;
            z-index: -2;
            background-image: linear-gradient(
                54.31deg,
                #076fc9 -24.46%,
                #6d2b9a 123.83%
                );
            transition: opacity 0.8s ease;
            will-change: opacity;
        }

        &:hover::before {
            opacity: 0;
        }

        &:hover::after {
            opacity: 1;
        }
    }

    &__mask {
        content: '';
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        z-index: -1;
        inset: 0;
        border-radius: 100vmax;
        padding: 1px;
        mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        will-change: transform;

        #{$root}--gradient & {
            mask: none;
            z-index: 1;
        }

        &::before {
            content: '';
            position: absolute;
            width: 110%;
            height: 200%;
            transform: rotate(8deg);
            transition: transform 800ms ease;
            background-image: linear-gradient(
                106.95deg,
                #181818 13.24%,
                rgba(24, 24, 24, 0) 29.86%,
                rgba(24, 24, 24, 0) 60.25%,
                #181818 86.44%
            );

            #{$root}--gradient & {
                display: none;
            }
        }
    }

    &:hover span::before {
        transform: rotate(187deg);
    }
}
</style>
